import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/ssr';
import 'swiper/dist/css/swiper.css';

Vue.use(VueAwesomeSwiper);
